var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('User'),_c('Shortcuts'),_c('History'),((_vm.$route.path.match(new RegExp('^\/persons', 'i')) || _vm.$route.path.match(new RegExp('^\/person/[0-9]+/edit', 'i'))) && _vm.authorized.person.update)?_c('Registration'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }